// Direcrtive to add the mobile prefix to the number on the "Your Details" page
angular.module('westBerkshireEvents.clientNumber').directive('fdClientNumber', () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: false,
    controller: numberFormatter
  };

  function numberFormatter($rootScope) {
    // Check if not on registration page and has a number
    if ($rootScope.member && $rootScope.member.mobile) {
        $rootScope.member.temp_mobile = (`+(${$rootScope.member.phone_prefix})${$rootScope.member.mobile}`);
    }
  }
});


// WEBPACK FOOTER //
// ../src/public/javascripts/client-number/client-number.component.js